<template>
    <sub-page :fullPage="true" :title="`${userName}的学情统计`">
        <div class="credit-wrap">
            <div :span="24" class="credit-left">
                <data-tables class="form-table"
                             ref="recordTable"
                             :data="creditTable"
                             :table-props="tableProps"
                             :current-page.sync="currentPage"
                             :page-size="20"
                             :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                             header-align="center"
                             v-loading="tableLoading"
                >
                    <el-table-column type="index" width="40" align="center"></el-table-column>
                    <el-table-column property="imageName" label="图像名称" align="center" show-overflow-tooltip
                                     sortable>
                    </el-table-column>
                    <el-table-column property="knowledge" label="知识点" align="center" show-overflow-tooltip
                                     sortable>

                    </el-table-column>
                    <el-table-column property="totalSeconds" label="时长" align="center" show-overflow-tooltip
                                     sortable>
                    </el-table-column>
                    <el-table-column property="recordtime" label="学习时间" min-width="120" align="center" show-overflow-tooltip
                                     sortable>

                    </el-table-column>
                    <!-- column buttons -->
                </data-tables>
            </div>
        </div>
    </sub-page>
</template>

<script>
    import api from '@/api';
    import SubPage from '@components/Subpage.vue';
    import SelectMultiple from '@components/Selectmultiple';
    export default {
        props: {
            'userID': String,
            // 'searchData':
            //     {
            //         type: Object,
            //         default() {
            //             return {
            //                 types: [],
            //                 afterDate: '',
            //                 beforeDate: '',
            //             }
            //         }
            //     },
            // 'userName': String
        },
        data() {
            return {
                // 表格信息开始
                creditTable: [],
                tableProps: {
                    border: true,
                    stripe: true,
                    rowKey: row => row.id,
                    height: "auto"
                },
                currentPage: 1,
                formSearch:{
                    types:[],
                    startTime:'',
                    endTime:'',
                    limit:-1
                },
                tableLoading:true,
                afterDate: '',
                beforeDate: '',
                userName: ''
            }
        },
        created() {
            let routeQuery = this.$route.query
            this.afterDate = routeQuery.afterDate
            this.beforeDate = routeQuery.beforeDate
            this.userName = routeQuery.userName

            this.$nextTick(() => {
                this.query();
            })
        },
        computed: {
        },
        methods: {
            query() {
                this.currentPage = 1;
                let queryData = {
                    afterDate: this.afterDate,
                    beforeDate: this.beforeDate,
                };

                api.getFiscanImageDetailStatistic(this.userID, queryData).then((res) => {
                    if (res.package) {
                        this.creditTable = res.package;
                        this.creditTable.forEach(item => {
                            const time = Number(item.totalSecounds.toFixed(2))
                            item.totalSeconds = this.getHMSTime(time)
                        });
                    }
                    this.tableLoading=false;
                })
            },
            //当前日期
            currentDate(num){
                let myDate = new Date();
                if(num>0){
                    myDate=new Date(myDate - 1000 * 60 * 60 * 24 * 30*num)
                }
                let nowY = myDate.getFullYear();
                let nowM = myDate.getMonth()+1;
                let nowD = myDate.getDate();
                let enddate = nowY+"-"+(nowM<10 ? "0" + nowM : nowM)+"-"+(nowD<10 ? "0"+ nowD : nowD);//当前日期
                return enddate
            },

            getHMSTime (second_time) {
                var time = second_time + "秒";
                if( second_time > 60){
                    var second = parseInt(second_time) % 60;
                    var min = parseInt(second_time / 60);
                    time = min + "分钟" + second + "秒";
                    if( min > 60 ){
                        min = parseInt(second_time / 60) % 60;
                        var hour = parseInt( parseInt(second_time / 60) /60 );
                        time = hour + "小时" + min + "分钟" + second + "秒";
                        if( hour > 24 ){
                            hour = parseInt( parseInt(second_time / 60) /60 ) % 24;
                            var day = parseInt( parseInt( parseInt(second_time / 60) /60 ) / 24 );
                            time = day + "天" + hour + "小时" + min + "分钟" + second + "秒";
                        }
                    }
                }
                return time
            },
        },
        watch: {},
        components: {
            SubPage,
            SelectMultiple,
        }

    }
</script>

<style scoped lang="scss">
    .credit-wrap{
        height: 100%;
        display: flex;
    }
    .credit-left,.credit-right{
        height: 100%;
        border: 1px solid #ebebed;

    }
    .credit-left{
        width: 100%;
        /*margin-right: 20px;*/
        padding: 10px;
    }
    .form-table {
        display: flex;
        flex: 1;
        flex-direction: column;
        height: 98%;
    }
</style>
